import BaseController from "vamos/cockpit/base/controller/type/BaseController";
import Dialog from "sap/m/Dialog";
import ApiService from "vamos/cockpit/base/services/type/ApiService";
import ValidationUtil from "vamos/cockpit/base/util/ValidationUtil";
import { GlobalOrderPeriod, OrderPeriodOverrideRequest, ResponseGlobalOrderPeriod } from "vamos/cockpit/model/api/vamos.private.api.types";
import { showSuccess } from "vamos/cockpit/base/handler/MessageToastHandler";

/**
 * @namespace vamos.cockpit.data.supplier.controller
 * */
export type OrderPeriodDialogViewModel = Omit<GlobalOrderPeriod, "fromDate" | "tillDate"> & {
    fromDate: Date;
    tillDate: Date;
};

export default class OrderPeriodDialogController extends BaseController {
    private dialog: Dialog;

    onInit(): void {
        super.onInit();
        this.dialog = this.getView().byId("orderPeriodDialog") as Dialog;
    }

    public async openDialog(): Promise<void> {
        const response = await ApiService.getInstance().getRestJsonData<ResponseGlobalOrderPeriod>("/supplier/global-order-period");
        const override: GlobalOrderPeriod = response.content ?? {};
        const data: OrderPeriodDialogViewModel = {
            guid: override.guid ?? "",
            days: override.days ?? 0,
            fromDate: override.fromDate ? new Date(override.fromDate) : null,
            tillDate: override.tillDate ? new Date(override.tillDate) : null,
        };
        this.viewModel.setData(data);
        this.dialog.open();
    }

    public onClosePopup(): void {
        this.dialog.close();
    }

    public async onSave(): Promise<void> {
        if (ValidationUtil.hasEmptyRequiredFields(this.dialog)) {
            return;
        }

        const data = this.viewModel.getData() as OrderPeriodDialogViewModel;
        const payload: OrderPeriodOverrideRequest = {
            days: data.days,
            from: data.fromDate?.toISOString(),
            to: data.tillDate?.toISOString(),
        };
        await ApiService.getInstance().postRestJsonData("/supplier/global-order-period-override", payload);
        showSuccess(this.getText("OrderPeriodAbsenceSaved"));
        this.dialog.close();
    }

    public async onDelete(): Promise<void> {
        const data:OrderPeriodDialogViewModel = this.viewModel.getData() as OrderPeriodDialogViewModel;
        const guid: string = data.guid;
        if(guid){
            await ApiService.getInstance().delete(`/supplier/global-order-period/${guid}`);
            showSuccess(this.getText("OrderPeriodAbsenceDeleted"));
        }
        this.dialog.close();
    }
}
